import Resource from './common/resource';

class Files extends Resource {
  path = 'files';

  onCreateOne({ dispatch, commit }, { model, res }) {
    dispatch('users/sendAchievement', 'imported_files', { root: true });
    commit('update', { model, update: res.data, action: 'prepend' });
  }
}

export default Files;
